import { createReducer } from 'store/utils';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import { RootActions } from 'store/types';
import { AdminHideQuestionType } from 'api/types';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory<AdminHideQuestionType>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const hideQuestionsReducer = createReducer<State, Actions>(initialState, {
  [actions.hideAdminQuestion.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.hideAdminQuestion.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.hideAdminQuestion.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.hideAdminQuestion.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default hideQuestionsReducer;
